import { HamburgerMenuIcon } from "@radix-ui/react-icons";
import { ChevronLeft } from "lucide-react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Div from "src/components/typography/div";
import { Button } from "src/components/ui/button";
import useDevice from "src/lib/hooks/useDevice";
import { TabItems } from "./header";
import { useAuth } from "src/lib/useAuth";

function Sidebar({ user }: any) {
  const [expanded, setExpanded] = useState(true);

  const device = useDevice();
  const { appState } = useAuth();
  const { pathname } = useLocation();

  useEffect(() => {
    if (device === "mobile") {
      setExpanded(false);
    }
  }, [device]);

  return (
    <Div
      className={`bg-inherit space-y-4 ${
        expanded ? "w-[290px]" : "w-20"
      }  h-screen transition-all sticky top-0 duration-500 `}
    >
      <div className="w-full  text-right">
        <Button
          variant="ghost"
          className="hover:bg-gray-800"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? (
            <ChevronLeft className="text-white" />
          ) : (
            <HamburgerMenuIcon className="text-white w-full h-full" />
          )}
        </Button>
      </div>

      <img
        className="  w-full max-w-[250px]  transition-all duration-300  mx-auto "
        src={expanded ? "/logo.webp" : "/logo-192.png"}  
        alt="logo"
      />

      <TabItems pathname={pathname} tabs={appState.tabs} expanded={expanded} />
    </Div>
  );
}

export default Sidebar;
